import React, { useEffect } from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { Button } from '@nextiva/next-ui-components';
import { useSelector } from 'react-redux';

import { ContentContainer } from 'components';
import { Page } from 'containers';

import { useSnackbar } from 'hooks';
import { getResetStatus } from './duck/actions';
import { isLoading, getStatus } from './duck/selectors';
import styles from './ResetDataStatus.scss';
import ProgressBarWrapper from './ProgressBar';

const ResetData = ({ children }) => {
  const loading = useSelector(isLoading);
  const error = useSelector((state) => state.resetData.errors);
  const status = useSelector(getStatus);
  const setSnackbar = useSnackbar();

  useEffect(() => {
    getResetStatus(setSnackbar);
  }, []);

  const resetData = () => {
    if (status.active) return;
    window.location.hash = '/reset-data-status/reset';
  };

  return (
    <ContentContainer>
      <BreadcrumbsItem
        to="/reset-data-status"
        data-testid="PlatformAdminUI-ResetDataStatus-BreadcrumbsItem"
      >
        Reset Data
      </BreadcrumbsItem>
      <Page title="Reset Data" showBreadcrumbs loading={loading} error={error}>
        <div>
          <div className={styles.resetDataProgressContainer}>
            <ProgressBarWrapper />
            <h1>
              Reset Data Status:&nbsp;
              <span style={{ color: status.error || error ? 'red' : 'green' }}>
                {status.message}
              </span>
            </h1>
          </div>
          <div className={styles.resetDataContainer}>
            <div>
              <h1>Reset Data</h1>
              <p>
                This will clear all the data except demo data and SSO data
                (user, permissions, departments), that is added by default for
                every sales account.
              </p>
            </div>
            <Button
              color="danger"
              onClick={resetData}
              disabled={status.active}
              data-testid="PlatformAdminUI-ResetDataStatus-Button"
            >
              Reset Data
            </Button>
          </div>
        </div>
        {children}
      </Page>
    </ContentContainer>
  );
};

export default ResetData;
